module.exports = __webpack_public_path__ + "static/media/carta_88.07c9ebfe.jpg";